import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=0763e1e2&scoped=true"
import script from "./ErrorMessage.vue?vue&type=script&lang=ts"
export * from "./ErrorMessage.vue?vue&type=script&lang=ts"
import style0 from "./ErrorMessage.vue?vue&type=style&index=0&id=0763e1e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0763e1e2",
  null
  
)

export default component.exports